import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-search',
  templateUrl: './member-search.component.html',
  styleUrls: ['./member-search.component.css']
})
export class MemberSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
